export const en = {
    action_paid: 'Paid',
    info: 'Transfer to the “Paid“ status',
    title: 'Paid transaction?',
};
